export class ContentNavigationHelper {
  static scrollToTop = () => {
    const element = document.querySelector('.center-container');

    if (element) {
      element.scrollTo({ top: 0 });
    }
  };
}
